import React from 'react';

const SHEET_ID = '1Nphyqod2IrE9mdfCZCUo8gOnTAr7dI6rjbO_VdJsPYs';
const SHEET_URL = `https://docs.google.com/spreadsheets/d/${SHEET_ID}`;

export default function ActivitiesTab({ config }) {
  const hasEditWebhook = config.editWebhookUrl && config.editWebhookUrl.trim() !== '';

  return (
    <div>
      <a
        href={SHEET_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="activities-sheet-link"
      >
        📊 Abrir Google Sheets
      </a>

      <p className="activities-section-title">Edición desde la app</p>

      {!hasEditWebhook ? (
        <div className="activities-notice">
          <strong>Edición integrada no configurada</strong>
          Para editar actividades directamente desde aquí, crea un webhook en n8n que actualice el Google Sheets y añade su URL en <em>Configuración → URL webhook edición Google Sheets</em>.
        </div>
      ) : (
        <div className="activities-notice" style={{ background: '#f0fff4', borderColor: '#9ae6b4', color: '#276749' }}>
          <strong>Webhook de edición configurado</strong>
          La edición integrada está disponible. En una próxima versión se mostrará aquí la tabla de actividades editable.
        </div>
      )}
    </div>
  );
}
